<template>
    <a-checkbox v-model="value"><slot></slot></a-checkbox>
</template>

<script>
   import StateMixin from "./StateMixin";

   export default {
      name: "StateCheckbox",
      mixins: [StateMixin],
   }
</script>

<style scoped>

</style>